import { Component, OnInit } from '@angular/core';
import { NotifierService } from 'angular-notifier';
import { Message } from 'src/app/core/class/message';
import { CommonService } from 'src/app/core/services/common.service';
import { BaseComponent } from 'src/app/shared/components/base/base.component';

@Component({

  selector: 'app-general-category',
  templateUrl: './general-category.component.html',
  styleUrls: ['./general-category.component.scss']
})
export class GeneralCategoryComponent extends BaseComponent implements OnInit {

  constructor(
    public commonService: CommonService,
    public message: Message,
    private notifier: NotifierService
  ) {
    super(commonService, message);
    this.notifier = notifier;
  }

  ngOnInit() {
  }

}
